import {AbstractControl, ValidatorFn} from '@angular/forms';

function isValidPhoneNumber(phoneNumber?: string): boolean {
  if (typeof phoneNumber !== 'string') {
    return false;
  }

  const reg = /^(\+48)?[0-9]{9}$/g;

  return reg.test(phoneNumber.replace(/\s/g, ''));
}

export function validPhoneNumber(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null =>
    (!control.value || isValidPhoneNumber(control.value))
      ? null : {invalidPhoneNumber: true};
}
